import { observer } from "mobx-react-lite";
import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import { translationHookOptions } from "../../app/localization/localization";
import { RootStoreContext } from "../../app/stores/rootStore";
import GenericModal from "../common/GenericModal";
import NoteForm from "../forms/NoteForm";

const NoteModalContainer: React.FC = () => {
  const rootStore = useContext(RootStoreContext);
  const { showNoteModal, closeShowNoteModal, noteModalParams } =
    rootStore.playerStore;
  const [t] = useTranslation(["browse_page"], translationHookOptions);

  return (
    <>
      {noteModalParams &&
      (noteModalParams.contentId || noteModalParams.fileId) ? (
        <GenericModal
          title={
            noteModalParams.contentId
              ? t("toolbar_notes_form_title_content")
              : t("toolbar_notes_form_title_file")
          }
          isOpen={showNoteModal}
          size="md"
          toggle={closeShowNoteModal}
          content={<NoteForm params={noteModalParams} />}
        ></GenericModal>
      ) : (
        <></>
      )}
    </>
  );
};

export default observer(NoteModalContainer);
